export default {
	tenantId: "asia_uat",
	appId: "covergo_crm",

	fileSystem: {
		bucketName: "asia--uat"
	}
}
